
import React, { } from 'react';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import './TableCatalogueContainer.css';
import ReactTooltip from 'react-tooltip';
import { v4 as uuidv4 } from 'uuid';
// @ts-ignore
import styles from './Catalog.module.css';
import Link from '../../../../Components/Link';
import { ProductThumb } from '../../../../Components/Product/ProductThumb';
import { ProductRequestResultProduct } from '../../../../Services/SearchProductFeedTypes';

type TableCatalogueContainerType = {
	data: ProductRequestResultProduct[]
}

export default function TableCatalogueContainer({
	data
}: TableCatalogueContainerType) {

	const tooltipID = uuidv4();

	return (
		<>
			<div className={styles.table}>
				<div className="table_flex">
					<div className='table_row table_head_row'>
						<div className='table_col'>Product</div>
						<div className='table_col'>Price</div>
						<div className='table_col'>Price rebate</div>
						<div className='table_col'>Stock</div>
						<div className='table_col'>Categories</div>
						<div className='table_col'>Tags</div>
						<div className='table_col'>Variants</div>
						<div className='table_col'>Description</div>
					</div>
					{data.map((prd, i) =>
						<div key={i + '_' + prd.id} className='table_row table_body_row'>
							<div className='table_col'>
								<ProductThumb
									width={60}
									url={prd.urlThumbnail ?? ''}
									alt={prd.id}
								/>
								<div className={styles.product_main_data}>
									<div className={styles.product_id}>{prd.id}</div>
									<div className={styles.product_name}>
										{prd.url ?
											<Link target="_blank" href={prd.url}>
												{prd.name}
											</Link>
											:
											<>{prd.name}</>
										}
									</div>
								</div>
							</div>
							<div className='table_col'>{prd.price}</div>
							<div className='table_col'>{prd.unitPriceWithRebate}</div>
							<div className='table_col'>
								{typeof prd.globalStockQuantity == 'number' ? prd.globalStockQuantity : '-'}
							</div>
							<div className='table_col'>
								{(prd.categories || []).length > 0 ?
									<div className={styles.product_category_list}>
										{(prd.categories || []).map((cat, j) =>
											<div key={j}>
												<div
													className={styles.product_category}
													data-for={tooltipID}
													data-tip={cat._type + '=' + cat._name}>
													{cat._type}={cat._name}
												</div>
											</div>
										)}
									</div>
									:
									<>-</>
								}
							</div>
							<div className='table_col'>
								{(prd.tags || []).length > 0 ?
									<div className={styles.product_category_list}>
										{(prd.tags || []).map((tag, j) =>
											<div key={j}>
												<div
													className={styles.product_category}
													data-for={tooltipID}
													data-tip={tag.fullString}>
													{tag.fullString}
												</div>
											</div>
										)}
									</div>
									:
									<>-</>
								}
							</div>
							<div className='table_col'>
								{(prd.productVariants || []).length > 0 ?
									<div>
										{(prd.productVariants || []).map((elem, j) =>
											<div key={j}>
												{elem.productVariantId}&nbsp;
												<span className='s_12 grey_2'>(Stock: {elem.stockQuantity})</span>
											</div>
										)}
									</div>
									:
									<>-</>
								}
							</div>
							<div className='table_col'>{prd.description || '-'}</div>
						</div>
					)}
				</div>
			</div>
			<ReactTooltip
				id={tooltipID}
				backgroundColor="black"
				effect="solid"
				place="bottom"
				globalEventOff="click"
				delayShow={100}
			/>
		</>
	);
}